const SESSION = '@uTriper/auth';

export const getSession = () => {
    try {
        const sessionData = localStorage.getItem(SESSION);
        if (!sessionData) return null;

        const data = JSON.parse(sessionData);
        return data?.accessToken ?? null;
    } catch (err) {
        console.error('@uTriper [getSession]: ', err.message);
        return null;
    }
};

export const setSession = (accessToken) => {
    localStorage.setItem(SESSION, JSON.stringify({ accessToken }));
};

export const removeSession = () => {
    localStorage.removeItem(SESSION);
};
